/**
 * Kiosk 5-inch Mockup Component
 * Wrapper for customizer that reads state from store and passes to unified KioskPreview
 * Based on Figma: node-id=3743-5142
 */

import React from 'react';
import { KioskUICustomization } from '../../types/kiosk-types';
import { KioskPreview } from './KioskPreview';
import { useKioskCustomizerStore } from '../../stores/kiosk-customizer-store';

interface KioskMockup5inchProps {
  config: KioskUICustomization;
}

/**
 * Kiosk 5-inch Mockup Component
 * Used in the customizer - reads pending state from store
 */
export function KioskMockup5inch({ config }: KioskMockup5inchProps) {
  // Get pending logo from store for live preview
  const pendingMedia5Logo = useKioskCustomizerStore((state) => state.pendingMedia5Logo);
  const pendingLogoUrl = pendingMedia5Logo?.previewUrl;

  // Get idle screen state from store
  const pendingMedia5IdleScreen = useKioskCustomizerStore((state) => state.pendingMedia5IdleScreen);
  const showIdleScreenInPreview = useKioskCustomizerStore((state) => state.showIdleScreenInPreview);

  // Use media5Logo if available, otherwise fall back to generic logo
  const media5Logo = config.icons.media5Logo || config.icons.logo;
  const logoSrc = pendingLogoUrl || media5Logo?.s3Url || media5Logo?.fallbackUrl;

  return (
    <KioskPreview
      config={config}
      pendingLogoUrl={logoSrc}
      pendingIdleScreen={pendingMedia5IdleScreen}
      showIdleScreen={showIdleScreenInPreview}
    />
  );
}
